export default __webpack_public_path__ + "static/media/product_01.1 .fe9d0b2a.png";